import React from 'react';
import styled from '@emotion/styled';
import { mixins, colors } from 'ech-components/src/core/styles/theme/default';
import { NavSearch } from 'ech-components/src/components';
import { Link } from 'ech-components/src/primitives';
import { rem } from 'polished';
import { useIntl } from 'react-intl';

const StyledNavbar = styled.nav`
  display: flex;
  align-items: center;
  margin-right: -0.5rem;
  margin-left: auto;

  ${mixins.responsiveStyles({
    height: { zero: 56, medium: 80 },
  })}

  .hamburger {
    padding: ${rem(13)} ${rem(8)};
    margin: ${rem(6)} ${rem(8)};
    color: ${colors.secondarySoftPurple800};

    .label {
      ${mixins.MQMax('medium')} {
        ${mixins.visuallyHidden};
      }
    }

    .line {
      background: ${colors.secondarySoftPurple800};
    }

    .hamburger-active & {
      &,
      &:hover,
      &:focus {
        color: ${colors.white};
      }

      .line {
        background: ${colors.white};
      }
    }
  }
`;

const StyledLink = styled(Link)`
  display: inline-flex;
  vertical-align: top;
`;

const Navbar = ({
  menuTitle,
  toggleHamburger,
  hamburgerActive,
  searchSubmitText,
}: NavbarProps) => {
  const intl = useIntl();

  return (
    <StyledNavbar>
      {searchSubmitText && (
        <NavSearch
          hamburgerActive={hamburgerActive}
          searchSubmitText={searchSubmitText}
          formAction={`/${intl.locale}/search`}
        />
      )}
      <StyledLink
        linkText={menuTitle}
        variant="hamburger"
        onClick={toggleHamburger}
        color={hamburgerActive ? 'light' : colors.secondarySoftPurple800}
        tabIndex={0}
        aria-label={menuTitle}
        aria-labelledby="main-menu-content"
        aria-controls="main-menu"
        aria-haspopup="true"
        aria-expanded={hamburgerActive ? 'true' : 'false'}
        role="button"
      />
    </StyledNavbar>
  );
};

export type NavbarProps = {
  hamburgerActive?: any;
  toggleHamburger: any;
  menuTitle: string;
  searchSubmitText?: string;
};

export default Navbar;
